import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 0px 24px 24px 24px;
`;
